module.exports = __webpack_public_path__ + "static/media/chrpe_desc1.2938d3c7.jpg";